
jQuery( document ).ready(function($) {

	
	//-----------------------------
	//		Row separator
	//-----------------------------
	var svg = {
		'angle' : {
			'points' : '50,0 0,100 100,100',
			'ref' : {x:100, y:100},
		},
		'angle_left' : {
			'points' : '60,0 0,90 90,90',
			'ref' : {x:90, y:90},
		},
		'angle_right' : {
			'points' : '30,0 0,90 90,90',
			'ref' : {x:90, y:90},
		},
		'tilt_right' : {
			'points' : '100,0 0,100 100,100',
			'ref' : {x:100, y:100},
		},
		'tilt_left' : {
			'points' : '0,0 0,100 100,100',
			'ref' : {x:100, y:100},
		},
	};


	function setup_row(){
		row_num = 0; //need to uncache fill for svg
		$('.row_separator_wrap').each(function(){
			row_num++;
			var $select = $(this);
			var $related_row ;
			var $row_separator =  $select.find('.row_separator');

			var separator_height = $select.attr('height');
			
			if (!separator_height){separator_height = 5; }

			//var row_separator_wrap_height = $row_separator.outerHeight();
			var row_separator_wrap_height = Math.round(parseFloat(separator_height) * $row_separator.outerWidth() / 100);
			$row_separator.css('height', row_separator_wrap_height+'px');

			
			if ($select.find('.row_separator_top_wrap').exist()){  // Top separator
				$related_row = $select.next('.vc_row');

				$related_row.attr('related_separator_top', row_num);
				
				//add padding to previous row
				$select.prevAll('.vc_row').first().css({
					'padding-bottom': row_separator_wrap_height+'px',
				});
			}
			else if ($select.find('.row_separator_bottom_wrap').exist()){ // Bot separator
				//$related_row = $select.prevUntil('.vc_row').first().prev();
				$related_row = $select.prevAll('.vc_row').first();
				
				

				$related_row.attr('related_separator_bottom', row_num);

				
				//add padding to next row
				$select.nextAll('.vc_row').first().css({
					'padding-top': row_separator_wrap_height+'px',
				});
			}
			
			//row heigh
			var row_height = (typeof $related_row.attr('row_height') != 'undefined' ? parseFloat($related_row.attr('row_height')) : 0);
			$related_row.attr('row_height', row_height + row_separator_wrap_height);			
			$select.attr('row_separator_num', row_num);

			

			
		//}).promise().done( function(){ resize_shape(); } );
		}).promise().done( function(){ setTimeout(function(){ resize_shape(); }, 50); } );
		
		
	}
	
	
	function resize_shape(){
		
		//row_num = 0; //need to uncache fill for svg
		$('.row_separator_wrap').each(function(){
			
			var $select = $(this);
			var row_num = $(this).attr('row_separator_num');
			var $related_row;
			var $row_separator =  $select.find('.row_separator');
			var row_separator_wrap_height = $row_separator.outerHeight();
			var row_separator_wrap_width = $row_separator.outerWidth();
			var row_max_height = 0;
			var row_max_width = 0;
			var row_placement ;
			var shape =  $(this).attr('shape');
			var is_double_separate_row =  false;
			
			
			if ($select.find('.row_separator_top_wrap').exist()){ //if is top
				$related_row = $('.vc_row[related_separator_top="'+row_num+'"]');
				row_placement = 'top';
				$select.css({'margin-top': '-'+row_separator_wrap_height+'px'});
			}
			else if ($select.find('.row_separator_bottom_wrap').exist()){
				$related_row = $('.vc_row[related_separator_bottom="'+row_num+'"]');
				row_placement = 'bottom';
			}

			//round height to avoid half pixel issue
			/*$row_separator.css({
				'height': Math.round(row_separator_wrap_height),
				'padding-bottom': 0,

			});*/

			
			//row max size
			row_max_height = parseFloat($related_row.attr('row_height')) + $related_row.outerHeight(true) ;
			row_max_width = $related_row.outerWidth();
			
			//is_double_separate_row
			if ($related_row.is('[related_separator_bottom][related_separator_top]')){
				is_double_separate_row = true;
			}



			//if ($related_row.is('.vc_row-has-fill')){
				var bg_img ;
				var $new_bg = $related_row.children('.new_bg');
				if (!$new_bg.exist()){
					bg_img = $related_row.css('background-image').replace(/url\((['"])?(.*?)\1\)/gi, '$2');
				}else{
					bg_img = $new_bg.css('background-image').replace(/url\((['"])?(.*?)\1\)/gi, '$2');
				}

				var pattern = ''; 
				var pattern_size = {
					'width' : row_separator_wrap_width,
					'height' : row_separator_wrap_height
				}
				var compensate_y =  '0';
				var compensate_x =  '0';
				
				
				if (bg_img != 'none'){ //img bg
					
					if (!$new_bg.exist()){
						

						var related_bg_pos =  $related_row.css('background-position').split(' ');
						if(related_bg_pos.length < 2){
							related_bg_pos[1] = related_bg_pos[0];
						}
						related_bg = {
							'position' : $related_row.css('background-position'),
							'position_x' : related_bg_pos[0],
							'position_y' : related_bg_pos[1],
							'color' : $related_row.css('background-color'),
							'repeat' : $related_row.css('background-repeat'),
							'image' : $related_row.css('background-image'),
							'size' : $related_row.css('background-size'),
						}


						
						$related_row.append('<div class="new_bg"></div>');
						
						
						$new_bg = $related_row.find('.new_bg');
						$new_bg.css({
								//'background' : $related_row.css('background'),
								'background-image' : related_bg['image'],
								'background-color' : related_bg['color'],
								'background-size' : related_bg['size'],
								'background-position' : related_bg['position'],
								'background-repeat' : related_bg['repeat'],
								//'top' : '-'+$related_row.css('margin-top'),
								'left' : '0',
								'position': 'absolute',
								//'height': elemDim.height+'px',
								//'width': elemDim.width+'px',
								'z-index': '-1',
							});
						
						$related_row.css({
							'overflow': 'hidden',
							//'background': 'none !important'
						})
						.addClass('has_row_separator')
						
						
						
						
					}

					$new_bg.css({
								//'top' : '-'+$related_row.css('margin-top'),
								//'top' : '-'+top_new_bg+'px',
								'width': row_max_width+'px',
								'height':  row_max_height+'px',
					});
					if (row_placement == 'top'){
						$new_bg.css({
							'top' : '-'+row_separator_wrap_height+'px',
						});
					}
					
					
					var bg_size = getBackgroundSize($new_bg);



					//if (bg_size.height >= row_max_height && related_bg_pos[1] == '50%'  ){
					if ( related_bg['position_y'] == '50%'  ){
						compensate_y = -(bg_size.height -  row_max_height ) / 2  ;
					}
					//if (bg_size.width >= row_max_width && related_bg_pos[0] == '50%' ){
					if ( related_bg['position_x'] == '50%' ){
						compensate_x = -(bg_size.width - row_max_width) /2  ;
					}
					rotation = ''
					if (row_placement == 'bottom'){
						rotation = 'transform="translate('+bg_size.width+','+bg_size.height+') rotate(180 0 0)"';

						if  (related_bg['position_y'] != '50%'){
							compensate_y = -(bg_size.height -  row_max_height )  ;
						}
						if  (related_bg['position_x'] != '50%'){
							compensate_x = -(bg_size.width - row_max_width)  ;
						}
						/*if (!is_double_separate_row){
							compensate_y += row_separator_wrap_height;
						}*/
					}
					
					if (related_bg['color'] != 'rgba(0, 0, 0, 0)' && related_bg['color'] != "transparent"){
						pattern += '<rect x="0" y="0" width="'+bg_size.width+'" height="'+bg_size.height+'" style="fill: '+related_bg['color']+';" />';
					}
					
					var no_repeat_trick_attr = '';
					pattern_width = bg_size.width;
					pattern_height = bg_size.height;

					if ( related_bg['size'] == 'contain'){
						
						if (row_placement == 'bottom'){
							no_repeat_trick_attr = ' x="-'+row_separator_wrap_width+'" y="-'+row_separator_wrap_height+'" ';
						}else{
							no_repeat_trick_attr = ' x="'+row_separator_wrap_width+'" y="'+row_separator_wrap_height+'" ';
						}
						pattern_width = pattern_width + row_separator_wrap_width;
						pattern_height = pattern_height + row_separator_wrap_height;						
						compensate_x =  compensate_x  - row_separator_wrap_width;
						compensate_y =  compensate_y  - row_separator_wrap_height;

					}

					pattern += '<image  '+no_repeat_trick_attr+' width="'+bg_size.width+'" height="'+bg_size.height+'" '+rotation+' \
															preserveAspectRatio="xMidYMid    slice" \
															xlink:href="'+bg_img+'" \
														/>';



					pattern_size = {
						'width' : pattern_width,
						'height' : pattern_height
					}

					
					
					
				}else{ //color_bg
					//$select.find('svg .shape').css({'fill':$related_row.css('background-color')});
					//$select.find('svg rect').addClass('active').append("<rect x='0' y='0' width='100%' height='100%' style='fill:"+$related_row.css('background-color')+";'></rect>");

					//var bg_color = $related_row.css('background-color');
					var bg_color = $('body').css('background-color');
					if ($related_row.is('.vc_row-has-fill')){
						bg_color = $related_row.css('background-color');
					}
					
					pattern = '<rect  x="0" y="0" width="100%" height="100%"  style="fill:'+bg_color+';" >';

				}
				
				// Create SVG
				var shape_html ;
				var fill =  "url("+window.location.pathname+"#pat"+row_num+")";
				
				/*if (shape == 'angle'){
					//var points = row_separator_wrap_width/2+',0 0,'+ row_separator_wrap_height +' '+ row_separator_wrap_width + ','+ row_separator_wrap_height;
					var points = '50,0 0,100 100,100';
					points = resize_points(points, 100,100 , row_separator_wrap_width, row_separator_wrap_height);
					//shape_html = '<polygon class="shape angle"  points="'+row_separator_wrap_width/2+',0 0,'+ row_separator_wrap_height +' '+ row_separator_wrap_width + ','+ row_separator_wrap_height+'" width="100%"  height="100%"   fill="'+fill+'">';
					shape_html = '<polygon class="shape angle"  points="'+points+'" width="100%"  height="100%"   fill="'+fill+'">';
				}
				else if (shape == 'angle_left'){
					var points = '60,0 0,90 90,90';
					points = resize_points(points, 90,90 , row_separator_wrap_width, row_separator_wrap_height);
					//shape_html = '<polygon class="shape angle_left"  points="'+row_separator_wrap_width/3+',0 0,'+ row_separator_wrap_height +' '+ row_separator_wrap_width + ','+ row_separator_wrap_height+'" width="100%"  height="100%"   fill="'+fill+'">';
					shape_html = '<polygon class="shape angle_left"  points="'+points+'"  width="100%"  height="100%"   fill="'+fill+'">';
				}
				else if (shape == 'angle_right'){
					var points = '30,0 0,90 90,90';
					points = resize_points(points, 90,90 , row_separator_wrap_width, row_separator_wrap_height);
					//shape_html = '<polygon class="shape angle_right"  points="'+row_separator_wrap_width/1.5+',0 0,'+ row_separator_wrap_height +' '+ row_separator_wrap_width + ','+ row_separator_wrap_height+'" width="100%"  height="100%"   fill="'+fill+'">';
					shape_html = '<polygon class="shape angle_right"  points="'+points+'" width="100%"  height="100%"   fill="'+fill+'">';
				}
				else if (shape == 'tilt_right'){
					var points = '100,0 0,100 100,100';
					points = resize_points(points, 100,100 , row_separator_wrap_width, row_separator_wrap_height);
					//shape_html = '<polygon class="shape tilt_right"  points="'+row_separator_wrap_width+',0 0,'+ row_separator_wrap_height +' '+ row_separator_wrap_width + ','+ row_separator_wrap_height+'" width="100%"  height="100%"   fill="'+fill+'">';
					shape_html = '<polygon class="shape tilt_right"  points="'+points+'" width="100%"  height="100%"   fill="'+fill+'">';
				}
				else{ //tilt left
					var points = '0,0 0,100 100,100';
					points = resize_points(points, 100,100 , row_separator_wrap_width, row_separator_wrap_height);
					//shape_html = '<polygon class="shape tilt_left"  points="0,0 0,'+ row_separator_wrap_height +' '+ row_separator_wrap_width + ','+ row_separator_wrap_height+'" width="100%"  height="100%"   fill="'+fill+'">';
					shape_html = '<polygon class="shape tilt_left"  points="'+points+'" width="100%"  height="100%"   fill="'+fill+'">';
				}*/
				//var points = svg[shape]['point'];

				var points = resize_points(svg[shape].points, svg[shape].ref.x , svg[shape].ref.y , row_separator_wrap_width, row_separator_wrap_height);
				shape_html = '<polygon class="shape '+shape+'"  points="'+points+'" width="100%"  height="100%"   fill="'+fill+'">';

				$row_separator.find('svg').remove();
				$row_separator.append('<svg  width="100%" height="100%"   preserveAspectRatio="xMidYMid slice" overflow="visible"  >\
												<defs>\
													<pattern id="pat'+row_num+'" x="'+compensate_x+'" y="'+compensate_y+'" width="'+pattern_size.width+'" height="'+pattern_size.height+'" patternUnits="userSpaceOnUse"  patternContentUnits="objectBoundingBox" viewbox="0 0 '+pattern_size.width+' '+pattern_size.height+'"\
														preserveAspectRatio="xMidYMid slice">\
														'+pattern+'\
													</pattern>\
												</defs>\
												'+shape_html+'\
												\
											</svg>')

				/*shape_html = '<polygon class="shape tilt_left"  points="0,0 0,100 100,100" width="100"  height="100"   fill="'+fill+'">';
				
				//turn into percent
				function turn_into_percent(value, value_ref){
					if (typeof value == 'undefined'){return 0;}
					return value*100/value_ref;
				}

				var compensate_x_pcent = turn_into_percent(compensate_x, pattern_size.width);
				var compensate_y_pcent = turn_into_percent(compensate_x, pattern_size.width);
				var pattern_size_width_pcent = turn_into_percent(pattern_size.width, pattern_size.width);
				var pattern_size_height_pcent = turn_into_percent(pattern_size.height, pattern_size.height);




				$row_separator.find('svg').remove();
				$row_separator.append('<svg  width="100%" height="100%"   preserveAspectRatio="none" overflow="visible" viewBox="0 0 100 100" >\
												<defs>\
													<pattern id="pat'+row_num+'" \
														x="'+compensate_x_pcent+'" y="'+compensate_y_pcent+'"\
														width="'+pattern_size_width_pcent+'" height="'+pattern_size_height_pcent+'" \
														viewbox="0 0 '+pattern_size.width+' '+pattern_size.height+'"\
														patternUnits="userSpaceOnUse"  patternContentUnits="objectBoundingBox" \
														preserveAspectRatio="xMidYMid slice">\
														'+pattern+'\
													</pattern>\
												</defs>\
												'+shape_html+'\
												\
											</svg>')*/
				
			
			//}//end if vc row fill
			
			

		});
	
	}
	//after vc js
	setTimeout(function(){
		setup_row();
	}, 100);
	
	$( window ).resize(function() {
		resize_shape();
	});
 
	function resize_points(points, ref_width, ref_height, target_width, target_height) {
		var points = points.split(' ');
		for (var i in points){		
			var coordinate = points[i].split(',');
			for (var j in coordinate){
				if (j == 0){coordinate[j] = target_width*coordinate[j]/ref_width;}
				else{coordinate[j] = target_height*coordinate[j]/ref_height;}
				
			}
			points[i] = coordinate.join(',');
		}
		points = points.join(' ');
		return points;
	}

	function getBackgroundSize($elem) {
		// This:
		//       * Gets elem computed styles:
		//             - CSS background-size
		//             - element's width and height
		//       * Extracts background URL
		var elem = $elem[0];
		var computedStyle = getComputedStyle(elem),
			image = new Image(),
			src = computedStyle.backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2'),
			cssSize = computedStyle.backgroundSize,
			elemW = $elem.outerWidth(),
			elemH = $elem.outerHeight(),
			elemDim = [elemW, elemH],
			computedDim = [],
			ratio;
			
		// Load the image with the extracted URL.
		// Should be in cache already.
		image.src = src;
		// Determine the 'ratio'
		ratio = image.width > image.height ? image.width / image.height : image.height / image.width;
		// Split background-size properties into array
		cssSize = cssSize.split(' ');
		// First property is width. It is always set to something.
		computedDim[0] = cssSize[0];
		// If height not set, set it to auto
		computedDim[1] = cssSize.length > 1 ? cssSize[1] : 'auto';

		if(cssSize[0] === 'cover') {

			// Width is greater than height
			if(elemDim[0] > elemDim[1]) {
				// Elem's ratio greater than or equal to img ratio
				if(elemDim[0] / elemDim[1] >= ratio) {
					computedDim[0] = elemDim[0];
					computedDim[1] = 'auto';
				} else {
					computedDim[0] = 'auto';
					computedDim[1] = elemDim[1];
				}
			} else {
				computedDim[0] = 'auto';
				computedDim[1] = elemDim[1];
			}
		} else if(cssSize[0] === 'contain') {
			// Width is less than height
			if(elemDim[0] < elemDim[1]) {
				computedDim[0] = elemDim[0];
				computedDim[1] = 'auto';
			} else {
				// elem's ratio is greater than or equal to img ratio
				if(elemDim[0] / elemDim[1] >= ratio) {
					computedDim[0] = 'auto';
					computedDim[1] = elemDim[1];
				} else {
					computedDim[1] = 'auto';
					computedDim[0] = elemDim[0];
				}
			}
		} else {
			// If not 'cover' or 'contain', loop through the values
			for(var i = cssSize.length; i--;) {
				// Check if values are in pixels or in percentage
				if (cssSize[i].indexOf('px') > -1) {
					// If in pixels, just remove the 'px' to get the value
					computedDim[i] = cssSize[i].replace('px', '');
				} else if (cssSize[i].indexOf('%') > -1) {
					// If percentage, get percentage of elem's dimension
					// and assign it to the computed dimension
					computedDim[i] = elemDim[i] * (cssSize[i].replace('%', '') / 100);
				}
			}
		}
		// If both values are set to auto, return image's 
		// original width and height
		if(computedDim[0] === 'auto' && computedDim[1] === 'auto') {
			computedDim[0] = image.width;
			computedDim[1] = image.height;
		} else {
			// Depending on whether width or height is auto,
			// calculate the value in pixels of auto.
			// ratio in here is just getting proportions.
			ratio = computedDim[0] === 'auto' ? image.height / computedDim[1] : image.width / computedDim[0];
			computedDim[0] = computedDim[0] === 'auto' ? image.width / ratio : computedDim[0];
			computedDim[1] = computedDim[1] === 'auto' ? image.height / ratio : computedDim[1];
		}
		// Finally, return an object with the width and height of the
		// background image.
		return {
			width: computedDim[0],
			height: computedDim[1]
		};
	}



});
